import React from 'react';
import LearnMore from './LearnMore';
import content from './HowWorksContent';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/pro-light-svg-icons';

const HowWorksRight = ({ openModal, isVisible }) => (
  <div className="section-1__how-works--right">
    <h2 className="section-1__header section-1__header--sub">
      How it works
    </h2>
    {content.para.map((paragraph, index) => (
      <div className="section-1__how-works__panel__img">
        <div className="section-1__how-works__panel__img__circle">
          <FontAwesomeIcon icon={faCircle} fixedWidth size="2x" />
          <span className="section-1__how-works__panel__img__number">
            {index + 1}
          </span>
        </div>
        <span>{paragraph}</span>
      </div>
    ))}
    <div className="section-1__link">
      <LearnMore to="/download" text="Download the app" />
    </div>
  </div>
);

export default HowWorksRight;



// WEBPACK FOOTER //
// ./src/components/Static/LandingPageNYC/HowWorksRight.js